import React from "react";
import { useParams } from 'react-router-dom';
import CadastrarObra from "./CadastrarObras";

const EditarObra = () => {
    const { id } = useParams();

    return <CadastrarObra obraId={id} />;
};

export default EditarObra;
